const config = {
  API_URL: process.env.REACT_APP_API_URL,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  // API_URL_V2: process.env.REACT_APP_API_URL_V2,
};
export default config;
